/* Phone plan comparer. Reads plan data from <script type="application/json" data-pc-data> (built weekly from
   carriers' own sites, see docs/plan-compare/README.md) and renders picks, filters, results and a compare table.
   Filters never empty out silently: with no exact match it shows the closest plans and which filter to relax. */
(function () {
  'use strict';
  var root = document.querySelector('[data-pc]');
  if (!root) return;
  var src = root.querySelector('[data-pc-data]');
  var DATA;
  try { DATA = JSON.parse(src.textContent); } catch (e) { return; }
  if (!DATA || !DATA.plans || !DATA.plans.length) return;

  var PROVS = { AB: 'Alberta', BC: 'British Columbia', MB: 'Manitoba', NB: 'New Brunswick', NL: 'Newfoundland and Labrador', NS: 'Nova Scotia', NT: 'Northwest Territories', NU: 'Nunavut', ON: 'Ontario', PE: 'Prince Edward Island', QC: 'Quebec', SK: 'Saskatchewan', YT: 'Yukon' };
  var GB_OPTS = [0, 5, 20, 50, 100];
  var PRICE_OPTS = [0, 25, 30, 40, 50, 60, 80];
  var TERMS = [[30, 'Monthly'], [60, '60 days'], [90, '90 days'], [180, '6 months'], [365, 'Yearly']];
  var TYPES = [['all', 'All plans'], ['post', 'Postpaid'], ['pre', 'Prepaid'], ['byod', 'BYOD']];
  var PAGE = 24;
  var carriers = {};
  DATA.carriers.forEach(function (c) { carriers[c.s] = c; });
  var plans = DATA.plans.filter(function (p) { return carriers[p.c] && typeof p.p === 'number'; });
  plans.forEach(function (p, i) {
    p._i = i; p._id = p.id || ('p' + i);
    // Monthly equivalent for 90/365-day prepaid plans, and data size for comparing (unlimited high-speed counts as most).
    p._m = p.t === 'pre' && p.d && p.d !== 30 ? p.p * 30 / p.d : p.p;
    p._gb = p.gb != null ? (p.dy ? p.gb * 30 / p.d : p.gb) : (p.u ? 9999 : 0);
    p._term = termOf(p);
  });
  // Bucket a plan's billing period into the term tabs.
  function termOf(p) { var d = p.t === 'pre' && p.d ? p.d : 30; return d <= 31 ? 30 : d <= 62 ? 60 : d <= 95 ? 90 : d <= 200 ? 180 : 365; }

  var DEF = { prov: 'ON', type: 'all', term: 30, gb: 0, max: 0, talk: false, unl: false, g5: false, us: false, carriers: [], sort: 'price', view: 'grid' };
  var S = JSON.parse(JSON.stringify(DEF));
  var shown = PAGE;
  var picked = [];

  function $(sel, el) { return (el || root).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
  function money(n) { return '$' + (Math.round(n * 100) % 100 ? n.toFixed(2) : String(Math.round(n))); }
  function cname(p) { return carriers[p.c].n; }
  function per(p) { return p._term === 30 ? '/mo' : p._term === 365 ? '/year' : p._term === 180 ? '/6 months' : '/' + p.d + ' days'; }
  function is5g(p) { return /5G/i.test(p.g || ''); }
  function dataTxt(p) {
    if (p.gb == null) return p.u ? 'Unlimited' : 'No data';
    var gb = p.gb >= 1 ? p.gb + ' GB' : Math.round(p.gb * 1000) + ' MB';
    if (p.dy) gb += ' for the ' + (p.d >= 360 ? 'year' : p.d + ' days');
    return p.u ? gb + ' high-speed, then unlimited' : gb;
  }
  function dataShort(p) { return p.gb == null ? (p.u ? 'Unlimited' : 'No data') : (p.gb >= 1 ? p.gb + ' GB' : Math.round(p.gb * 1000) + ' MB'); }
  function perGb(p) { return p.gb ? p._m / p._gb : Infinity; }
  function inProv(p, prov) { return !p.pv || p.pv.indexOf('ALL') > -1 || p.pv.indexOf(prov) > -1; }
  function fmtDate(d) {
    var t = new Date(d + 'T12:00:00');
    return isNaN(t) ? d : t.toLocaleDateString('en-CA', { month: 'long', day: 'numeric', year: 'numeric' });
  }

  /* ---------- filtering ---------- */
  var TESTS = {
    // BYOD shows every plan: all prices here are bring-your-own-phone prices.
    type: function (p) { return S.type === 'all' || S.type === 'byod' || p.t === S.type; },
    term: function (p) { return p._term === S.term; },
    // Yearly plans are filtered on the data they list for the year.
    gb: function (p) { return !S.gb || (p.dy ? p.gb : p._gb) >= S.gb; },
    max: function (p) { return !S.max || p._m <= S.max; },
    talk: function (p) { return !S.talk || !p._gb; },
    unl: function (p) { return !S.unl || !!p.u; },
    g5: function (p) { return !S.g5 || is5g(p); },
    us: function (p) { return !S.us || !!p.us; },
    carriers: function (p) { return !S.carriers.length || S.carriers.indexOf(p.c) > -1; }
  };
  var LABEL = {
    type: function () { return S.type === 'pre' ? 'Prepaid' : 'Postpaid'; },
    term: function () { return termName(S.term); },
    gb: function () { return S.gb + ' GB+'; },
    max: function () { return 'Under ' + money(S.max) + '/mo'; },
    talk: function () { return 'Talk & text only'; },
    unl: function () { return 'Unlimited'; },
    g5: function () { return '5G'; },
    us: function () { return 'Canada-US'; },
    carriers: function () { return S.carriers.map(function (c) { return carriers[c].n; }).join(', '); }
  };
  function termName(t) { for (var i = 0; i < TERMS.length; i++) if (TERMS[i][0] === t) return TERMS[i][1]; return ''; }
  function isOn(k) {
    return k === 'carriers' ? S.carriers.length > 0 : k === 'type' ? S.type === 'post' || S.type === 'pre' : k === 'term' ? S.term !== 30 : !!S[k];
  }
  function active() { return Object.keys(TESTS).filter(isOn); }
  function provPlans() { return plans.filter(function (p) { return inProv(p, S.prov); }); }
  function match(list, skip) {
    return list.filter(function (p) {
      for (var k in TESTS) { if (k !== skip && !TESTS[k](p)) return false; }
      return true;
    });
  }
  function sortList(list) {
    var f = {
      price: function (a, b) { return a._m - b._m || b._gb - a._gb; },
      'price-desc': function (a, b) { return b._m - a._m; },
      data: function (a, b) { return b._gb - a._gb || a._m - b._m; },
      pergb: function (a, b) { return perGb(a) - perGb(b) || a._m - b._m; }
    }[S.sort] || function (a, b) { return a._m - b._m; };
    return list.slice().sort(f);
  }

  /* ---------- best picks (computed, never hand-picked) ---------- */
  function cheapest(list) { return list.slice().sort(function (a, b) { return a._m - b._m || b._gb - a._gb; })[0]; }
  function renderPicks() {
    var L = provPlans().filter(function (p) { return p._term === 30; });
    var defs = [
      ['Cheapest with data', function (p) { return p.gb > 0 || p.u; }],
      ['Cheapest 20 GB+', function (p) { return p._gb >= 20; }],
      ['Cheapest 50 GB+', function (p) { return p._gb >= 50; }],
      ['Cheapest 100 GB+', function (p) { return p._gb >= 100; }],
      ['Cheapest Canada-US', function (p) { return p.us && (p.gb > 0 || p.u); }],
      ['Cheapest prepaid', function (p) { return p.t === 'pre' && (p.gb > 0 || p.u); }],
      ['Cheapest 5G', function (p) { return is5g(p) && (p.gb > 0 || p.u); }]
    ];
    var seen = {};
    var html = defs.map(function (d) {
      var p = cheapest(L.filter(d[1]));
      if (!p) return '';
      var dup = seen[p._id]; seen[p._id] = 1;
      if (dup) return '';
      return '<button type="button" class="pc-pick" data-pc-goto="' + esc(p._id) + '"><span class="pc-pick__tag">' + esc(d[0]) + '</span>' +
        '<span class="pc-pick__who">' + logo(carriers[p.c], 'pc-logo pc-logo--sm') + esc(cname(p)) + ' · ' + esc(dataShort(p)) + '</span><span class="pc-pick__name">' + esc(p.n) + '</span>' +
        '<span class="pc-pick__price">' + money(p.p) + '<small>' + per(p) + '</small></span></button>';
    }).join('');
    $('[data-pc-picks]').innerHTML = html;
    $('[data-pc-picks-prov]').textContent = PROVS[S.prov];
  }

  /* ---------- cards ---------- */
  function card(p) {
    var c = carriers[p.c];
    var facts = '<li><b>Data</b><span>' + esc(dataTxt(p)) + (p.sc ? ' (' + esc(p.sc) + ')' : '') + '</span></li>' +
      '<li><b>Network</b><span>' + (p.g ? esc(p.g) + (c.net && c.net !== c.n ? ' on ' + esc(c.net) : '') : esc(c.net || c.n)) + '</span></li>' +
      (p.tk ? '<li><b>Talk</b><span>' + esc(p.tk) + '</span></li>' : '') +
      (p._term !== 30 ? '<li><b>Term</b><span>' + p.d + ' days</span></li>' : '');
    var tags = [];
    if (p.mx) tags.push('Canada-US-Mexico'); else if (p.us) tags.push('Canada-US');
    (p.x || []).slice(0, 3).forEach(function (x) { tags.push(x); });
    if (p.was) tags.unshift('Price drop, was ' + money(p.was));
    if (p.nw) tags.unshift('New this week');
    var on = picked.indexOf(p._id) > -1;
    return '<article class="pc-card" id="pc-' + esc(p._id) + '">' +
      '<div class="pc-card__top">' + logo(c, 'pc-logo', c.n) +
      '<span class="pc-card__type">' + (p.t === 'pre' ? 'Prepaid' : 'Postpaid') + '</span></div>' +
      '<div class="pc-card__name"><small>' + esc(c.n) + '</small>' + esc(p.n) + '</div>' +
      // Always the same six blocks, so grid view can line them up across a row (CSS subgrid).
      '<div class="pc-card__pricebox"><div class="pc-card__price">' + money(p.p) + '<small>' + per(p) + '</small></div>' +
      (p._m !== p.p ? '<div class="pc-card__cond">About ' + money(Math.round(p._m * 100) / 100) + ' a month</div>' : '') +
      (p.pc ? '<div class="pc-card__cond">' + esc(p.pc) + (p.pr ? ' (' + money(p.pr) + ' without)' : '') + '</div>' : '') +
      (p.pm ? '<span class="pc-card__promo">' + esc(p.pm) + '</span>' : '') + '</div>' +
      '<ul class="pc-facts">' + facts + '</ul>' +
      '<div class="pc-tags">' + tags.map(function (t) { return '<span class="pc-tag' + (/^(New this|Price drop)/.test(t) ? ' pc-tag--hot' : '') + '">' + esc(t) + '</span>'; }).join('') + '</div>' +
      '<div class="pc-card__foot"><label class="pc-cmp"><input type="checkbox" data-pc-pick="' + esc(p._id) + '"' + (on ? ' checked' : '') + '> Compare</label>' +
      '<a class="pc-btn pc-btn--ghost pc-btn--sm" href="' + esc(p.src || c.url) + '" target="_blank" rel="nofollow noopener">See on ' + esc(c.n) + ' ↗</a></div>' +
      '</article>';
  }

  /* ---------- results ---------- */
  function render() {
    var L = provPlans();
    var res = sortList(match(L));
    var act = active();
    var notice = '';
    var list = res;
    if (!res.length && L.length) {
      // Find which single filter, if dropped, brings plans back. Offer those, and show the closest plans meanwhile.
      var fixes = act.map(function (k) { return { k: k, n: match(L, k).length }; }).filter(function (f) { return f.n; });
      fixes.sort(function (a, b) { return a.n - b.n; });
      notice = '<div class="pc-notice" role="status"><strong>No plan matches every filter in ' + esc(PROVS[S.prov]) + '.</strong> Showing the closest plans instead. Drop one filter:<br>' +
        (fixes.length ? fixes.map(function (f) { return '<button type="button" class="pc-btn pc-btn--ghost pc-btn--sm" data-pc-drop="' + f.k + '">Remove "' + esc(LABEL[f.k]()) + '" (' + f.n + ')</button>'; }).join('') :
          '<button type="button" class="pc-btn pc-btn--ghost pc-btn--sm" data-pc-reset>Reset all filters</button>') + '</div>';
      list = closest(L);
    }
    $('[data-pc-count]').textContent = res.length ? res.length + (res.length === 1 ? ' plan' : ' plans') : '0 exact matches';
    $('[data-pc-where]').textContent = 'Prices for ' + PROVS[S.prov] + ', before tax. Checked ' + fmtDate(DATA.checked) + '.';
    if (S.type === 'byod' && !notice) notice = '<div class="pc-info">Every plan on this page works with a phone you already own. These are each carrier\'s bring-your-own-phone (BYOD) prices, with no phone financing attached.</div>';
    $('[data-pc-notice]').innerHTML = notice;
    renderTabs(L);
    renderActives();
    syncSide(L, res.length, act.some(function (k) { return k !== 'type'; }));
    var g = $('[data-pc-grid]');
    g.classList.toggle('is-list', S.view === 'list');
    g.innerHTML = list.slice(0, shown).map(card).join('') || '<p>No plans listed for ' + esc(PROVS[S.prov]) + ' yet.</p>';
    var more = $('[data-pc-more]');
    more.hidden = list.length <= shown;
    more.textContent = 'Show ' + Math.min(PAGE, list.length - shown) + ' more of ' + (list.length - shown);
    syncControls();
    renderTray();
    writeUrl();
  }
  function closest(L) {
    // Score every plan by how far it misses each active filter, so near misses come first.
    return L.map(function (p) {
      var s = 0;
      if (!TESTS.type(p)) s += 3;
      if (!TESTS.carriers(p)) s += 3;
      if (!TESTS.g5(p)) s += 2;
      if (!TESTS.us(p)) s += 2;
      if (!TESTS.unl(p)) s += 2;
      if (!TESTS.talk(p)) s += 3;
      if (!TESTS.term(p)) s += 4;
      if (!TESTS.max(p)) s += (p._m - S.max) / 10;
      if (!TESTS.gb(p)) s += p._gb ? (S.gb - p._gb) / Math.max(S.gb, 1) * 3 : 3;
      return { p: p, s: s };
    }).sort(function (a, b) { return a.s - b.s || a.p._m - b.p._m; }).slice(0, 12).map(function (x) { return x.p; });
  }
  /* ---------- filter bar: type tabs + one row of dropdowns ---------- */
  var PRICE_MIN = 20, PRICE_MAX = 100;
  var EXTRAS = [['unl', 'Unlimited data'], ['us', 'Canada-US'], ['g5', '5G'], ['talk', 'Talk & text only']];
  var CHEV = '<svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true"><path d="M2 3.5 5 6.5 8 3.5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  // How many plans would show if filter k were set to v (other filters kept).
  function countWith(L, k, v) { var o = S[k]; S[k] = v; var n = match(L).length; S[k] = o; return n; }
  // Carrier logo from the theme assets (base URL on the section), or initials when a carrier has none.
  var LOGO_BASE = root.getAttribute('data-pc-logos') || '';
  function logo(c, cls, alt) {
    if (c.lg && LOGO_BASE) return '<img class="' + cls + '" src="' + esc(LOGO_BASE.replace('carrier-x.png', 'carrier-' + c.s + '.png')) + '" alt="' + esc(alt ? alt + ' logo' : '') + '" height="40" loading="lazy">';
    return '<span class="' + cls + ' pc-mono" aria-hidden="true">' + esc(c.n.replace(/[^A-Za-zÀ-ÿ]/g, '').slice(0, 2)) + '</span>';
  }
  function renderTabs(L) {
    $('[data-pc-types]').innerHTML = TYPES.map(function (t) {
      var n = countWith(L, 'type', t[0]);
      return '<button type="button" class="pc-tab" role="tab" aria-selected="' + (S.type === t[0]) + '" data-pc-type="' + t[0] + '">' + t[1] + ' <span class="pc-tab__n">' + n + '</span></button>';
    }).join('');
  }
  /* ---------- filter sidebar: built once, then synced on every render ---------- */
  var SW = '<span class="pc-sw__box" aria-hidden="true"></span>';
  function buildSide() {
    var carrierBtns = DATA.carriers.filter(function (c) { return plans.some(function (p) { return p.c === c.s; }); }).map(function (c) {
      return '<button type="button" class="pc-sw" role="checkbox" aria-checked="false" data-pc-carrier="' + c.s + '">' + SW + logo(c, 'pc-logo pc-logo--opt', '') + '<span class="pc-sw__t">' + esc(c.n) + '</span><span class="pc-sw__n"></span></button>';
    }).join('');
    var featBtns = EXTRAS.map(function (x) {
      return '<button type="button" class="pc-sw" role="checkbox" aria-checked="false" data-pc-feat="' + x[0] + '">' + SW + '<span class="pc-sw__t">' + esc(x[1]) + '</span><span class="pc-sw__n"></span></button>';
    }).join('');
    var termBtns = TERMS.map(function (t) { return '<button type="button" class="pc-chip" data-pc-term="' + t[0] + '" aria-pressed="false">' + esc(t[1]) + '</button>'; }).join('');
    $('[data-pc-side]').innerHTML =
      '<div class="pc-side__grab" aria-hidden="true"></div>' +
      '<div class="pc-side__head"><b>Filters</b><button type="button" class="pc-side__clear" data-pc-reset>Clear all</button></div>' +
      '<div class="pc-side__body">' +
      '<div class="pc-fg"><h3>Billing</h3><div class="pc-chips">' + termBtns + '</div></div>' +
      '<div class="pc-fg"><h3>Max price <em data-pc-maxv></em></h3><input type="range" class="pc-range" min="' + PRICE_MIN + '" max="' + PRICE_MAX + '" step="5" aria-label="Maximum price per month" data-pc-range="max"><div class="pc-scale"><span>$' + PRICE_MIN + '</span><span>Any</span></div></div>' +
      '<div class="pc-fg"><h3>Min data <em data-pc-gbv></em></h3><input type="range" class="pc-range" min="0" max="' + (GB_OPTS.length - 1) + '" step="1" aria-label="Minimum data" data-pc-range="gb"><div class="pc-scale"><span>Any</span><span>' + GB_OPTS[GB_OPTS.length - 1] + ' GB+</span></div></div>' +
      '<div class="pc-fg"><h3>Carrier</h3><div class="pc-sws">' + carrierBtns + '</div></div>' +
      '<div class="pc-fg"><h3>Features</h3><div class="pc-sws">' + featBtns + '</div></div>' +
      '</div>' +
      '<div class="pc-side__foot"><button type="button" class="pc-btn" data-pc-fclose data-pc-fshow>Show plans</button></div>';
  }
  function syncSide(L, n, anyOn) {
    $$('[data-pc-term]').forEach(function (b) {
      var t = +b.getAttribute('data-pc-term'), c = countWith(L, 'term', t);
      b.setAttribute('aria-pressed', S.term === t); if (c) b.removeAttribute('data-empty'); else b.setAttribute('data-empty', '');
    });
    var mx = $('[data-pc-range="max"]'), gb = $('[data-pc-range="gb"]');
    var mv = S.max ? Math.min(Math.max(S.max, PRICE_MIN), PRICE_MAX) : PRICE_MAX;
    if (document.activeElement !== mx) mx.value = mv;
    var gi = Math.max(0, GB_OPTS.indexOf(S.gb)); if (document.activeElement !== gb) gb.value = gi;
    $('[data-pc-maxv]').textContent = S.max ? 'Up to ' + money(S.max) + '/mo' : 'Any';
    $('[data-pc-gbv]').textContent = S.gb ? S.gb + ' GB+' : 'Any';
    $$('[data-pc-carrier]').forEach(function (b) {
      var s = b.getAttribute('data-pc-carrier'), c = countWith(L, 'carriers', [s]);
      b.setAttribute('aria-checked', S.carriers.indexOf(s) > -1); $('.pc-sw__n', b).textContent = c;
      if (c || S.carriers.indexOf(s) > -1) b.removeAttribute('data-empty'); else b.setAttribute('data-empty', '');
    });
    $$('[data-pc-feat]').forEach(function (b) {
      var k = b.getAttribute('data-pc-feat'), c = countWith(L, k, true);
      b.setAttribute('aria-checked', !!S[k]); $('.pc-sw__n', b).textContent = c;
      if (c || S[k]) b.removeAttribute('data-empty'); else b.setAttribute('data-empty', '');
    });
    $('[data-pc-fshow]').textContent = n ? 'Show ' + n + (n === 1 ? ' plan' : ' plans') : 'Show closest plans';
    $('.pc-side__clear').hidden = !anyOn;
    var fc = $('[data-pc-fcount]'), cnt = active().filter(function (k) { return k !== 'type'; }).length;
    fc.hidden = !cnt; fc.textContent = cnt;
  }
  // Pills for what is switched on, each one removes itself.
  function renderActives() {
    var act = active().filter(function (k) { return k !== 'type'; });
    $('[data-pc-actives]').innerHTML = act.map(function (k) { return '<button type="button" class="pc-pill" data-pc-drop="' + k + '">' + esc(LABEL[k]()) + ' <span aria-hidden="true">×</span><span class="visually-hidden">remove</span></button>'; }).join('');
  }
  function closeDrawer() { document.body.classList.remove('pc-fs-open'); }
  function syncControls() {
    $('[data-pc-prov]').value = S.prov;
    $('[data-pc-sort]').value = S.sort;
    $$('[data-pc-view]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-pc-view') === S.view); });
  }

  /* ---------- compare ---------- */
  function byId(id) { for (var i = 0; i < plans.length; i++) if (plans[i]._id === id) return plans[i]; }
  function renderTray() {
    var t = $('[data-pc-tray]');
    t.classList.toggle('is-on', picked.length > 0);
    $('[data-pc-tray-n]').textContent = picked.length + ' of 3 picked';
    $('[data-pc-open]').disabled = picked.length < 2;
  }
  function openCompare() {
    var L = picked.map(byId).filter(Boolean);
    var minP = Math.min.apply(null, L.map(function (p) { return p._m; }));
    var maxG = Math.max.apply(null, L.map(function (p) { return p._gb; }));
    var rows = [
      ['Price', function (p) { return '<span class="' + (p._m === minP ? 'pc-best' : '') + '">' + money(p.p) + per(p) + '</span>'; }],
      ['Price condition', function (p) { return esc(p.pc || '—') + (p.pr ? ' (' + money(p.pr) + ' without)' : ''); }],
      ['Data', function (p) { return '<span class="' + (p._gb && p._gb === maxG ? 'pc-best' : '') + '">' + esc(dataTxt(p)) + '</span>'; }],
      ['After the cap', function (p) { return esc(p.u ? (p.sc ? 'Slowed to ' + p.sc : 'Slowed, no overage') : (p.gb == null ? '—' : 'Data stops or overage')); }],
      ['$ per GB', function (p) { return p.gb ? money(perGb(p)) : '—'; }],
      ['Network', function (p) { return esc((p.g ? p.g + ' on ' : '') + (carriers[p.c].net || carriers[p.c].n)); }],
      ['Type', function (p) { return p.t === 'pre' ? 'Prepaid' : 'Postpaid'; }],
      ['Talk and text', function (p) { return esc(p.tk || '—'); }],
      ['Canada-US', function (p) { return p.mx ? 'Canada-US-Mexico' : p.us ? 'Yes' : 'No'; }],
      ['Extras', function (p) { return esc((p.x || []).join(', ') || '—'); }],
      ['Promo', function (p) { return esc(p.pm || '—'); }],
      ['', function (p) { return '<a class="pc-btn pc-btn--sm" href="' + esc(p.src || carriers[p.c].url) + '" target="_blank" rel="nofollow noopener">See on ' + esc(cname(p)) + ' ↗</a>'; }]
    ];
    $('[data-pc-table]').innerHTML = '<thead><tr><th></th>' + L.map(function (p) { return '<th scope="col">' + esc(cname(p)) + '<br><small>' + esc(p.n) + '</small></th>'; }).join('') + '</tr></thead><tbody>' +
      rows.map(function (r) { return '<tr><th scope="row">' + r[0] + '</th>' + L.map(function (p) { return '<td>' + r[1](p) + '</td>'; }).join('') + '</tr>'; }).join('') + '</tbody>';
    var d = $('[data-pc-dialog]');
    if (d.showModal) d.showModal(); else d.setAttribute('open', '');
  }

  /* ---------- plain-language search ---------- */
  var CARRIER_RX = DATA.carriers.map(function (c) {
    var n = c.n.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ mobile| wireless| plus/g, '');
    return { s: c.s, rx: new RegExp('\\b' + n.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b') };
  });
  function parse(q) {
    var t = ' ' + q.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '') + ' ';
    var n = JSON.parse(JSON.stringify(DEF));
    n.prov = S.prov; n.view = S.view;
    var said = [];
    var m = t.match(/(?:under|below|less than|max|up to|<)\s*\$?\s*(\d{2,3})/) || t.match(/\$\s*(\d{2,3})/);
    if (m) { n.max = +m[1]; said.push('under ' + money(+m[1])); }
    m = t.match(/(\d{1,3})\s*(?:gb|gig)/);
    if (m) { n.gb = +m[1]; said.push(m[1] + ' GB+'); }
    if (/unlimited/.test(t)) { n.unl = true; said.push('unlimited'); }
    if (/\b5g\b/.test(t)) { n.g5 = true; said.push('5G'); }
    if (/year|annual/.test(t)) { n.term = 365; said.push('yearly'); }
    else if (/6.month|six.month/.test(t)) { n.term = 180; said.push('6 months'); }
    else if (/90.day/.test(t)) { n.term = 90; said.push('90 days'); }
    else if (/60.day/.test(t)) { n.term = 60; said.push('60 days'); }
    if (/talk (and|&) text|no data|talk only/.test(t)) { n.talk = true; said.push('talk & text'); }
    if (/byod|bring your own|own phone/.test(t)) { n.type = 'byod'; said.push('BYOD'); }
    if (n.type === 'byod') { /* keep */ } else if (/prepaid|pay as you go|no contract/.test(t)) { n.type = 'pre'; said.push('prepaid'); }
    else if (/postpaid|monthly plan/.test(t)) { n.type = 'post'; said.push('postpaid'); }
    if (/\b(us|usa|u\.s\.|united states|america|roaming|canada-us|travel)\b/.test(t)) { n.us = true; said.push('Canada-US'); }
    CARRIER_RX.forEach(function (c) { if (c.rx.test(t)) { n.carriers.push(c.s); said.push(carriers[c.s].n); } });
    Object.keys(PROVS).forEach(function (k) {
      if (new RegExp('\\b(' + PROVS[k].toLowerCase() + '|' + k.toLowerCase() + ')\\b').test(t) && !(k === 'ON' && / on /.test(t) && !/ontario/.test(t))) { n.prov = k; said.push(PROVS[k]); }
    });
    if (/most data|biggest|largest/.test(t)) { n.sort = 'data'; said.push('most data first'); }
    else if (/per gb|value/.test(t)) { n.sort = 'pergb'; said.push('best $ per GB'); }
    return { s: n, said: said };
  }
  function runSearch(q) {
    if (!q.trim()) return;
    var r = parse(q);
    S = r.s; shown = PAGE;
    $('[data-pc-parsed]').textContent = r.said.length ? 'Filters set: ' + r.said.join(' · ') : 'Try a price, data amount, carrier or province.';
    renderPicks(); render();
    $('[data-pc-results]').scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ---------- URL state (shareable links) ---------- */
  function writeUrl() {
    if (!history.replaceState) return;
    var q = new URLSearchParams(location.search);
    ['prov', 'type', 'term', 'gb', 'max', 'talk', 'unl', 'g5', 'us', 'carriers', 'sort'].forEach(function (k) { q.delete(k); });
    if (S.prov !== DEF.prov) q.set('prov', S.prov);
    if (S.type !== 'all') q.set('type', S.type);
    if (S.term !== 30) q.set('term', S.term);
    if (S.gb) q.set('gb', S.gb);
    if (S.max) q.set('max', S.max);
    ['talk', 'unl', 'g5', 'us'].forEach(function (k) { if (S[k]) q.set(k, 1); });
    if (S.carriers.length) q.set('carriers', S.carriers.join(','));
    if (S.sort !== 'price') q.set('sort', S.sort);
    var s = q.toString();
    try { history.replaceState(null, '', location.pathname + (s ? '?' + s : '') + location.hash); } catch (e) { /* sandboxed frames */ }
  }
  function readUrl() {
    var q = new URLSearchParams(location.search);
    if (PROVS[q.get('prov')]) S.prov = q.get('prov');
    if (/^(pre|post|byod)$/.test(q.get('type'))) S.type = q.get('type');
    if (termName(+q.get('term'))) S.term = +q.get('term');
    if (+q.get('gb') > 0) S.gb = +q.get('gb');
    if (+q.get('max') > 0) S.max = +q.get('max');
    ['talk', 'unl', 'g5', 'us'].forEach(function (k) { if (q.get(k)) S[k] = true; });
    if (q.get('carriers')) S.carriers = q.get('carriers').split(',').filter(function (c) { return carriers[c]; });
    if (/^(price|price-desc|data|pergb)$/.test(q.get('sort'))) S.sort = q.get('sort');
  }

  /* ---------- events ---------- */
  function set(k, v) { S[k] = v; shown = PAGE; if (k === 'prov') renderPicks(); render(); }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('button, [data-pc-goto]');
    if (!b || !root.contains(b)) return;
    if (b.hasAttribute('data-pc-type')) {
      var ty = b.getAttribute('data-pc-type');
      if (ty === 'post' && S.term !== 30) S.term = 30;  // postpaid is always monthly
      set('type', ty);
    } else if (b.hasAttribute('data-pc-term')) {
      var tm = +b.getAttribute('data-pc-term');
      if (tm !== 30 && S.type === 'post') S.type = 'all';
      set('term', tm);
    } else if (b.hasAttribute('data-pc-gb')) set('gb', +b.getAttribute('data-pc-gb'));
    else if (b.hasAttribute('data-pc-max')) set('max', +b.getAttribute('data-pc-max'));
    else if (b.hasAttribute('data-pc-fopen')) document.body.classList.add('pc-fs-open');
    else if (b.hasAttribute('data-pc-fclose')) closeDrawer();
    else if (b.hasAttribute('data-pc-feat')) { var f = b.getAttribute('data-pc-feat'); if (f === 'talk' && !S.talk) { S.gb = 0; S.unl = false; } if ((f === 'unl') && !S.unl) S.talk = false; set(f, !S[f]); }
    else if (b.hasAttribute('data-pc-view')) set('view', b.getAttribute('data-pc-view'));
    else if (b.hasAttribute('data-pc-carrier')) {
      var c = b.getAttribute('data-pc-carrier'), i = S.carriers.indexOf(c);
      if (i > -1) S.carriers.splice(i, 1); else S.carriers.push(c);
      set('carriers', S.carriers);
    } else if (b.hasAttribute('data-pc-reset')) { var prov = S.prov, view = S.view; S = JSON.parse(JSON.stringify(DEF)); S.prov = prov; S.view = view; shown = PAGE; $('[data-pc-parsed]').textContent = ''; render(); }
    else if (b.hasAttribute('data-pc-drop')) {
      var k = b.getAttribute('data-pc-drop');
      S[k] = k === 'carriers' ? [] : DEF[k];
      render();
    } else if (b.hasAttribute('data-pc-more')) { shown += PAGE; render(); }
    else if (b.hasAttribute('data-pc-try')) { $('[data-pc-q]').value = b.textContent; runSearch(b.textContent); }
    else if (b.hasAttribute('data-pc-goto')) goTo(b.getAttribute('data-pc-goto'));
    else if (b.hasAttribute('data-pc-apply')) {
      // Group guides: apply that group's filters and jump to the results.
      var ap = {}; try { ap = JSON.parse(b.getAttribute('data-pc-apply')); } catch (err) { /* keep defaults */ }
      var pv = S.prov, vw = S.view; S = JSON.parse(JSON.stringify(DEF)); S.prov = pv; S.view = vw;
      Object.keys(ap).forEach(function (k) { if (k in DEF) S[k] = ap[k]; });
      shown = PAGE; render();
      $('[data-pc-results]').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    else if (b.hasAttribute('data-pc-open')) openCompare();
    else if (b.hasAttribute('data-pc-clear')) { picked = []; render(); }
    else if (b.hasAttribute('data-pc-close')) $('[data-pc-dialog]').close();
  });
  function goTo(id) {
    var p = byId(id);
    if (!p) return;
    // Make sure the plan is visible: clear filters that hide it, then scroll to it.
    if (!match([p]).length) { var prov = S.prov, view = S.view; S = JSON.parse(JSON.stringify(DEF)); S.prov = prov; S.view = view; S.term = p._term; }
    var idx = sortList(match(provPlans())).indexOf(p);
    if (idx >= shown) shown = Math.ceil((idx + 1) / PAGE) * PAGE;
    render();
    var el = document.getElementById('pc-' + id);
    if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); el.classList.remove('is-flash'); void el.offsetWidth; el.classList.add('is-flash'); }
  }
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.hasAttribute('data-pc-prov')) set('prov', t.value);
    else if (t.hasAttribute('data-pc-sort')) set('sort', t.value);
    else if (t.hasAttribute('data-pc-pick')) {
      var id = t.getAttribute('data-pc-pick'), i = picked.indexOf(id);
      if (t.checked && i < 0) { if (picked.length >= 3) { t.checked = false; return; } picked.push(id); }
      if (!t.checked && i > -1) picked.splice(i, 1);
      renderTray();
    }
  });
  root.addEventListener('input', function (e) {
    var r = e.target.closest('[data-pc-range]');
    if (!r) return;
    var v = +r.value;
    if (r.getAttribute('data-pc-range') === 'max') set('max', v >= PRICE_MAX ? 0 : v);
    else set('gb', GB_OPTS[v]);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  $('[data-pc-form]').addEventListener('submit', function (e) { e.preventDefault(); runSearch($('[data-pc-q]').value); });

  /* ---------- init ---------- */
  var provSel = $('[data-pc-prov]');
  var have = {};
  plans.forEach(function (p) { (p.pv || []).forEach(function (v) { have[v] = 1; }); });
  provSel.innerHTML = Object.keys(PROVS).filter(function (k) { return have[k] || have.ALL; }).map(function (k) { return '<option value="' + k + '">' + PROVS[k] + '</option>'; }).join('');
  var cs = {}; plans.forEach(function (p) { cs[p.c] = 1; });
  $('[data-pc-stat-carriers]').textContent = Object.keys(cs).length;
  $('[data-pc-stat-plans]').textContent = plans.length;
  $('[data-pc-stat-date]').textContent = fmtDate(DATA.checked);
  // Fastest network speed in each carrier's current plans, for the "Which network" section.
  var RANK = ['3G', '4G', '4G LTE', '5G', '5G+'];
  var best = {};
  plans.forEach(function (p) { if (RANK.indexOf(p.g) > RANK.indexOf(best[p.c] || '')) best[p.c] = p.g; });
  $$('[data-pc-gen]').forEach(function (el) { var g = best[el.getAttribute('data-pc-gen')]; el.textContent = g ? 'Up to ' + g : ''; });
  // Sit the sticky tab bar under the store's sticky header.
  function setTop() { var h = document.querySelector('.header'); root.style.setProperty('--pc-top', (h ? h.getBoundingClientRect().height : 0) + 'px'); }
  setTop(); window.addEventListener('resize', setTop);
  buildSide();
  readUrl();
  root.classList.add('is-ready');
  renderPicks();
  render();
})();
